import React, { memo, useContext, useEffect } from 'react';
import GlobalContext from '../../contexts/GlobalContext';
import { CoachingBarState } from '../../types/coachingBar';

type Props = {
  coachingBarState: CoachingBarState;
  setCoachingBarState: Function;
  wiggleAnimationClass: string;
  coachingBarRef: React.RefObject<HTMLDivElement>;
}

const CoachingBar = (props: Props): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const { coachingBarState } = props;
  const pushGAEventForCoachingBar = (): void => {
    globalContext.gtm.setVirtualPage('New_Subscriber_Onboarding_Coaching_Bar');
    globalContext.gtm.pushVersionedEvent('2.x', 'CoachingBar', 'SysClosetedItems', 'closetedItems = ' + coachingBarState.userClosetCount);
  };
  let coachingBarMessage: string;

  if (coachingBarState.closetMinimumReachedFlag) {
    coachingBarMessage = globalContext.i18n.getText('improved_sub_onboarding_coaching_bar_acm_text_B');
  } else if (coachingBarState.closetCountRequired === coachingBarState.closetMinimumCount) {
    coachingBarMessage = globalContext.i18n.getText('improved_sub_onboarding_coaching_bar_bcm_text', {
      closetCountRequired: coachingBarState.closetCountRequired
    });
  } else if (coachingBarState.closetCountRequired === 2) {
    coachingBarMessage = globalContext.i18n.getText('improved_sub_onboarding_coaching_bar_2_to_acm_text', {
      closetCountRequired: coachingBarState.closetCountRequired
    });
  } else if (coachingBarState.closetCountRequired === 1) {
    coachingBarMessage = globalContext.i18n.getText('improved_sub_onboarding_coaching_bar_1_to_acm_text', {
      closetCountRequired: coachingBarState.closetCountRequired
    });
  } else {
    coachingBarMessage = globalContext.i18n.getText('improved_sub_onboarding_coaching_bar_n_to_acm_text', {
      closetCountRequired: coachingBarState.closetCountRequired
    });
  }

  useEffect(() => {
    const pageWrapperElem = document.getElementById('page-wrapper');

    if (pageWrapperElem) {
      pageWrapperElem.classList.add('faceted-mobile--spacing');
    }
  }, []);
  useEffect(() => {
    pushGAEventForCoachingBar();
  }, [coachingBarState.userClosetCount]);

  return (
    <div className={`coaching-bar js-coaching-bar ${props.wiggleAnimationClass}
    ${coachingBarState.displayCoachingPopup ? coachingBarState.coachingBarClass : ''}
    ${coachingBarState.coachingPopupBtnClass}`}
    ref={props.coachingBarRef}>
      <ul className="coaching-bar__items">
        {Array.from({ length: coachingBarState.closetMinimumCount }).map((_, index) => (
          <li
            key={`coaching-${index}`}
            className={`coaching-bar__closet ${index < coachingBarState.userClosetCount ? 'coaching-bar__closet--added' : ''}`}
          />
        ))}
      </ul>
      <p className="coaching-bar__message">{coachingBarMessage}</p>
    </div>
  );
};

export default memo(CoachingBar);
